var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.8 487.17",
    style: {
      enableBackground: "new 0 0 362.8 487.17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.78,455.96l23.41-23.4c6.51,6.5,15.33,10.16,24.54,10.16h138.12c9.2,0,18.03-3.66,24.54-10.16 c5.45-5.45,8.94-12.57,9.89-20.23l31.2-249.61H47.09l31.2,249.61c0.96,7.66,4.44,14.77,9.89,20.23L64.78,455.96z M112.72,482.72 h138.12c19.81,0,38.81-7.87,52.82-21.88c11.75-11.75,19.25-27.07,21.3-43.56l35.7-285.57c0.6-4.77-3.13-8.99-7.94-8.99H10.84 c-4.81,0-8.54,4.22-7.94,8.99l35.7,285.57c2.06,16.48,9.55,31.81,21.3,43.56C73.91,474.85,92.91,482.72,112.72,482.72 L112.72,482.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.6,212.75c11.03-0.63,20.48,7.8,21.11,18.82l8.02,140c0.63,11.03-7.8,20.48-18.82,21.11 s-20.48-7.8-21.11-18.82l-8.02-140C111.15,222.84,119.57,213.39,130.6,212.75L130.6,212.75z M233.11,212.75 c11.03,0.63,19.45,10.09,18.82,21.11l-8.02,140c-0.63,11.03-10.08,19.46-21.11,18.82s-19.46-10.09-18.82-21.11l8.02-140 C212.63,220.55,222.08,212.12,233.11,212.75L233.11,212.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.96,64.08c0-11.05,8.96-20,20-20h259.79c11.04,0,20,8.95,20,20s-8.96,20-20,20H51.96 C40.92,84.08,31.96,75.13,31.96,64.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.9,82.72c-11.05,0.02-20.02-8.92-20.04-19.96l-0.07-40c-0.02-11.05,8.91-20.02,19.96-20.04 c11.04-0.02,20.02,8.91,20.04,19.96l0.07,40C201.88,73.73,192.94,82.7,181.9,82.72z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d0d5eef0ac33b9162bb226afa169b9a7.svg";
export { ForwardRef as ReactComponent };